import gql from 'graphql-tag';

const RESPONSE_FRAGMENT = gql`
  fragment Commenter on users {
      user_id
      user_first_name
      user_last_name
  }
  fragment StudentSchool on student_college {
    college_id
    college_name
    category
    id
    student_sub
    admission_type
    app_deadline
    app_platform
    progress
    tracker_info
    status
    college_location
    __typename
  }
  fragment StudentSchoolComment on student_college_comments {
      id
      created_at
      comment
      user_id
      user {
        ...Commenter     
      }
  }
`;
export const GET_SCHOOLS = gql`
  query getSchools($student_sub: uuid!) {
    student_college(where: { student_sub: { _eq: $student_sub } }, order_by: [{app_deadline: asc}, { college_name: asc}]) {
      ...StudentSchool
    }
  }
  ${RESPONSE_FRAGMENT}
`;

export const ADD_SCHOOL = gql`
  mutation insert_college($input: student_college_insert_input!) {
    insert_student_college(objects: [$input]) {
      returning {
        ...StudentSchool
      }
    }
  }
  ${RESPONSE_FRAGMENT}
`;

export const UPDATE_SCHOOL = gql`
  mutation updateSchool($id: Int!, $input: student_college_set_input!) {
    row: update_student_college_by_pk(pk_columns: {id: $id}, _set: $input) {
        ...StudentSchool
    }
  }
  ${RESPONSE_FRAGMENT}
`;

export const DELETE_SCHOOL = gql`
  mutation deleteUser($id: Int!) {
    delete_student_college(
      where: {
        id: { _eq: $id }
      }
    ) {
      returning {
        ...StudentSchool
      }
    }
  }
  ${RESPONSE_FRAGMENT}
`;

export const GET_COMMENTS = gql`
    query getComments($schoolId: Int!) {
        rows: student_college_comments(where: {student_college_id: {_eq: $schoolId}}) {
            ...StudentSchoolComment   
        }
    }
    ${RESPONSE_FRAGMENT}
`

export const ADD_COMMENT = gql`
    mutation addComment($data: student_college_comments_insert_input!) {
        row: insert_student_college_comments_one(object: $data) {
            ...StudentSchoolComment
        }
    }
    ${RESPONSE_FRAGMENT}
`;
